export default __webpack_public_path__ + "static/media/ruthsroses.15aa50b4.svg";